export function pad(n: number) {
  return String(n).padStart(2, "0")
}

export function shuffle<T>(arr: T[]): T[] {
  const a = arr.slice()
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export function letterFor(i: number) {
  return ["A", "B", "C"][i]
}

export function modeLabel(mode: string | null, section: number | null) {
  if (mode === "study") return "Study Quiz"
  if (mode === "practice-short") return "Short Practice"
  if (mode === "practice-full") return "Practice Test"
  if (mode === "section") return `Section ${section} Drill`
  return ""
}
